<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
	<section id="login_hero" v-if="false">
		<a href="https://bit.ly/3GtslJq" target="_blank"><img src="/static/renew_img/bnr/login_top_banner_20220622.png"  alt=""></a>
	</section>
	<div class="content-wrapper" style="padding:20px 0">
		Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-terms" :to="{name: 'policyPage'}" target="_blank">個人情報の取り扱い</router-link>について<br>
		に同意の上、ログインしてください。
	</div>
	<section id="login">
    <login-forms />
		<div class="content-wrapper">
			<a class="" href="https://lin.ee/0rfNtli" target="_blank" ><img src="/static/renew_img/banner_line.png" class="banner-line pc"></a>
		</div>
	</section>
	<section class="banner-contents">
		<ul class="banner-box">
			<li>
				<a href="https://bit.ly/39KLMRh" target="_blank"><img src="/static/renew_img/bnr/mypage_middle_banner_20211229_001.png" class="banner"></a>
			</li>
		</ul>
	</section>
	<div class="content-wrapper">
		<a href="https://lin.ee/0rfNtli" target="_blank" ><img src="/static/renew_img/banner_line.png" class="banner-line sp"></a>
	</div>
	<section class="btn_top"><a class="btn_sub" href="/">トップへ戻る</a></section>


</div>
</template>
<script>
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
		fullscreenLoading: true
	}
  },
  created : function(){
    console.log('created')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {    
        const urlParams = new URLSearchParams(window.location.search);
        var from_page = urlParams.get("frompage");
        if (from_page) {
          this.$router.push('/format/' + from_page + '/edit/output')
        } else {
          this.$router.push('/mypage')
        }
      }
	  this.fullscreenLoading = false
    })
  },
  computed: {},
  mounted: function(){
  },
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
